import AnnualCheckUpAPI from '../../../APIs/LoginAPI/AnnualCheckUpAPI'
import router from '../../../../router'

export const annualCheckUp = {
    state: {
        acu_result: {},
        acu_clinics: {},
        recent_approval: null,
        revalidateApprovalFuncData: null
    },
    actions: {
        verifyACU({ commit }, payload) {
            AnnualCheckUpAPI.verifyACU(payload)
                .then(res => {
                    commit('ACU_RESULT', res.data)
                    return res.data
                })
                .then(data => {
                    if (data.APPROVE) {
                        router.push(
                            `/dashboard/annual-physical-exam/request/granted?OPPAN=${data.OPAN_N}`
                        )
                    } else {
                        router.push(
                            '/dashboard/annual-physical-exam/request/denied?OPPAN=NOT%20AVAILABLE'
                        )
                    }
                })
        },
        additionalClinics({ commit }, payload) {
            AnnualCheckUpAPI.additionalClinics(payload)
                .then(res => {
                    commit('ACU_CLINICS', res.data)
                })
                .catch(() => {
                    // console.log(error);
                })
        },
        getACURecentApproval({ commit }, payload) {
            AnnualCheckUpAPI.fetchRecentApproval(payload)
                .then(res => {
                    if (res.status === 200) {
                        // console.log('ACU_RECENT_APPROVAL: ', res.data.data);
                        commit('ACU_RECENT_APPROVAL', res.data.data)
                    } else {
                        commit('ACU_RECENT_APPROVAL', null)
                    }
                })
                .catch(() => {
                    // console.log(error);
                })
        },
        revalidateApproval(_, payload) {
            AnnualCheckUpAPI.fetchRecentApproval(payload).then(res => {
                if (res.status === 200) {
                    // console.log('success');
                } else {
                    // console.log('not success')
                }
            })
        },
        revalidateApprovalFunc({ commit }, payload) {
            AnnualCheckUpAPI.revalidateApproval(payload)
                .then(res => {
                    commit('REVALIDATE_APPROVAL_FUNC', res && res.data)
                })
                .catch(() => {
                    // console.error('Error revalidateApprovalFunc error: ', error)
                })
        }
    },
    mutations: {
        REVALIDATE_APPROVAL_FUNC(state, revalidateApprovalFuncData) {
            state.revalidateApprovalFuncData = revalidateApprovalFuncData
        },
        ACU_RESULT(state, acu_result) {
            state.acu_result = acu_result
        },
        ACU_CLINICS(state, acu_clinics) {
            state.acu_clinics = acu_clinics
        },
        ACU_RECENT_APPROVAL(state, recent_approval) {
            state.recent_approval = recent_approval
        }
    },
    getters: {
        revalidateApprovalFuncData(state) {
            return state.revalidateApprovalFuncData
        },
        getACUResult(state) {
            return state.acu_result
        },
        getACUClinics(state) {
            return state.acu_clinics
        },
        getACURecentOPPAN(state) {
            return state.recent_approval
        }
    }
}
